import {
  InfraHostCompanyEnum,
  InfrastructureStatusEnum,
  InfrastructureStatusTypes,
  InfraTypeEnum,
} from "@hooks/dtos/IInfrastructureDTO";
import {
  FaBan,
  FaCheckCircle,
  FaClock,
  FaDatabase,
  FaGlobe,
  FaPauseCircle,
  FaServer,
  FaTools,
} from "react-icons/fa";
import { FiCloud, FiHardDrive, FiShield } from "react-icons/fi";

export const infraTypeOptions = [
  { value: InfraTypeEnum.EC2, label: "EC2" },
  { value: InfraTypeEnum.VPS, label: "VPS" },
  { value: InfraTypeEnum.DATABASE, label: "Banco de dados" },
  { value: InfraTypeEnum.DOMAIN, label: "Domínio" },
  { value: InfraTypeEnum.STORAGE, label: "Storage" },
  { value: InfraTypeEnum.CDN, label: "CDN" },
  { value: InfraTypeEnum.OTHER, label: "Outro" },
];

export const infraHostOptions = [
  { value: InfraHostCompanyEnum.AWS, label: "AWS" },
  { value: InfraHostCompanyEnum.GODADDY, label: "GoDaddy" },
  { value: InfraHostCompanyEnum.HOSTINGER, label: "Hostinger" },
  { value: InfraHostCompanyEnum.DIGITAL_OCEAN, label: "DigitalOcean" },
  { value: InfraHostCompanyEnum.CLOUDFLARE, label: "Cloudflare" },
  { value: InfraHostCompanyEnum.OTHER, label: "Outro" },
];

export const infrastructureStatusOptions = [
  { value: InfrastructureStatusEnum.ACTIVE, label: "Ativo" },
  { value: InfrastructureStatusEnum.INACTIVE, label: "Inativo" },
  { value: InfrastructureStatusEnum.MAINTENANCE, label: "Manutenção" },
  { value: InfrastructureStatusEnum.PROVISIONING, label: "Provisionando" },
  { value: InfrastructureStatusEnum.STOPPED, label: "Parado" },
  { value: InfrastructureStatusEnum.DECOMMISSIONED, label: "Desativado" },
];

export const getInfrastructureStatusInfo = (
  status: InfrastructureStatusTypes
) => {
  switch (status) {
    case InfrastructureStatusEnum.ACTIVE:
      return {
        label: "Ativo",
        variant: "success",
        icon: FaCheckCircle,
      };
    case InfrastructureStatusEnum.MAINTENANCE:
      return {
        label: "Manutenção",
        variant: "warning",
        icon: FaTools,
      };
    case InfrastructureStatusEnum.PROVISIONING:
      return {
        label: "Provisionando",
        variant: "info",
        icon: FaClock,
      };
    case InfrastructureStatusEnum.STOPPED:
      return {
        label: "Parado",
        variant: "secondary",
        icon: FaPauseCircle,
      };
    case InfrastructureStatusEnum.DECOMMISSIONED:
      return {
        label: "Desativado",
        variant: "dark",
        icon: FaBan,
      };
    case InfrastructureStatusEnum.INACTIVE:
    default:
      return {
        label: "Inativo",
        variant: "danger",
        icon: FaBan,
      };
  }
};

export const getInfrastructureTypeIcon = (typeId: InfraTypeEnum) => {
  switch (typeId) {
    case InfraTypeEnum.DATABASE:
      return FaDatabase;
    case InfraTypeEnum.DOMAIN:
      return FaGlobe;
    case InfraTypeEnum.STORAGE:
      return FiHardDrive;
    case InfraTypeEnum.CDN:
      return FiShield;
    case InfraTypeEnum.EC2:
      return FiCloud;
    case InfraTypeEnum.VPS:
    case InfraTypeEnum.OTHER:
    default:
      return FaServer;
  }
};
